import ServicioMedicoService from "@/api/services/cobranza/nomencladores/ServicioMedicoService"
import Vue from "vue"

const state = () => ({
    servicios: [],
    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "tipo",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    }
})

const getters = {
    SERVICIOS: state => {
        return state.servicios
    },
    SERVICIOS_PAG: state => {
        return state.pagination
    }
}

const mutations = {
    SET_SERVICIOS: (state, payload) => {
        state.servicios = payload
    },

    SET_SERVICIOS_PAG: (state, payload) => {
        state.pagination = payload
    },

    ADD_SERVICIO: (state, payload) => {
        state.servicios.push(payload)
    },

    UPDATE_SERVICIO: (state, payload) => {
        state.servicios = state.servicios.map(el => (el.id === payload.id ? payload : el))
    },

    DELETE_SERVICIO: (state, payload) => {
        state.servicios = state.servicios.filter(el => el.id !== payload.id)
    }
}

const actions = {
    LOAD_SERVICIOS: async ({ commit, state }, { filter, servicioEstado }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }
            let { data, status, headers } = await ServicioMedicoService.get({ filter, servicioEstado, ...pagination })
            if (status === 200) {
                commit("SET_SERVICIOS", data)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los servicios médico, inténtelo nuevamente"
            })
        }
    },

    LOAD_ALL_SERVICIOS: async ({ commit }) => {
        try {
            let { data, status } = await ServicioMedicoService.getAll()
            if (status === 200) {
                commit("SET_SERVICIOS", data)
                return data
            }
        } catch (error) {
            if (error.response) {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    LOAD_ALL_RECORDS_SERVICIOS: async ({ commit }) => {
        try {
            let { data, status } = await ServicioMedicoService.getAllRecords()
            if (status === 200) {
                commit("SET_SERVICIOS", data)
                return null
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los servicios médico, inténtelo nuevamente"
            })
        }
    },

    LOAD_HISTORY_SERVICIOS: async ({ commit }, payload) => {
        try {
            let { data, status } = await ServicioMedicoService.getHistory(payload)
            if (status === 200) {
                commit("UPDATE_SERVICIO", data)
            }
            return null
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar el historial del servicio médico, inténtelo nuevamente"
            })
        }
    },

    ADD_SERVICIO: async ({ commit }, payload) => {
        try {
            let { data, status } = await ServicioMedicoService.post(payload)
            if (status === 201) {
                commit("ADD_SERVICIO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Agregando",
                    text: "El servicio médico ha sido agregado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido agregar el servicio médico, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    UPDATE_SERVICIO: async ({ commit }, payload) => {
        try {
            let { data, status } = await ServicioMedicoService.put(payload)
            if (status === 200) {
                commit("UPDATE_SERVICIO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "El servicio médico ha sido modificado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar el servicio médico, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    DELETE_SERVICIO: async ({ commit }, payload) => {
        try {
            let { status, data } = await ServicioMedicoService.delete(payload)
            if (status === 204) {
                commit("DELETE_SERVICIO", payload)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Eliminando",
                    text: "El servicio ha sido eliminado satisfactoriamente"
                })
            }
            if (status === 200) {
                commit("UPDATE_SERVICIO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Deshabilitando",
                    text: "El servicio médico ha sido deshabilitado satisfactoriamente"
                })
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido eliminar/deshabilitar el servicio médico, inténtelo nuevamente"
            })
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
